import { render } from "./MainCurrencys.vue?vue&type=template&id=6296f726&scoped=true"
import script from "./MainCurrencys.vue?vue&type=script&lang=js"
export * from "./MainCurrencys.vue?vue&type=script&lang=js"

import "./MainCurrencys.vue?vue&type=style&index=0&id=6296f726&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6296f726"]])

export default __exports__